import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { formatRut, RutFormat } from '@fdograph/rut-utilities';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MyValidators } from 'src/app/libs/my-validators';
import { ApiService } from 'src/app/services/api.service';
import { Guards } from '../../../interfaces/guards';
import { ApiEntryControlService } from '../../../api-entry-control.service';
import { State } from '@popperjs/core';

@Component({
  selector: 'app-edit-guard',
  templateUrl: './edit-guard.component.html',
  styleUrls: ['./edit-guard.component.css']
})
export class EditGuardComponent implements  OnChanges {
  constructor(
    private api: ApiEntryControlService,
    private apiFull: ApiService,
    private toast: ToastrService,
    private modal: NgbModal
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if(this.guard?.id>0){
      this.api.getGuardPositions().subscribe((r) => (this.positions = (r.data as any[]) ?? []), () => (this.positions = []));
      this.getState();
      this.get(this.guard?.id);
    }
  }

  @Output()
  success = new EventEmitter<boolean>();
  @Input()
  guard:Guards;

  states:any;
  form1 = new UntypedFormGroup({
    id:new UntypedFormControl(),
    name: new UntypedFormControl(),
    lastname: new UntypedFormControl(''),
    rut: new UntypedFormControl('',[Validators.required,MyValidators.rut]),
    email: new UntypedFormControl(''),
    phone: new UntypedFormControl(''),
    os10:new UntypedFormControl(),
    state_id:new UntypedFormControl(),
    position_id: new UntypedFormControl(''),
  });
  positions: { id: number; name: string }[] = [];
get(id:number){
  this.api.getGuard(id).subscribe((res)=>{
    this.toast.success(res.msg,"Gestión guardias");
    this.form1.patchValue({ ...(res.data as any), position_id: (res.data as any)?.position_id ?? '' });
  },e=>{
    this.toast.warning(e.error.mistakes,e.error.msg);
    this.modal.dismissAll();
  });
}
getState(){
  this.apiFull.getState().subscribe((res)=>{
    this.states=res.data;
  });
}
  update() {
    this.api.updateGuards(this.form1).subscribe(
      (res) => {
        this.toast.success(res.msg, 'Gestión Guardias');
        this.success.emit(true);
        this.modal.dismissAll();
      },
      (e) => {
        this.toast.warning(e.error.mistakes, e.error.msg,{enableHtml:true,closeButton:true});
      }
    );
  }
  onFormatRut(value: any) {
    if (value.target.value.length > 8) {
      this.form1
        .get('rut')
        ?.setValue(formatRut(value.target.value, RutFormat.DOTS_DASH));
    }
  }

 openModal(md: any, size = 'md') {
    this.modal.open(md, {
      size: 'xl',
    });
  }
}
